module.exports = __webpack_public_path__ + "static/media/sale.f89dc925.svg";